var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-ajc",attrs:{"id":"app"}},[_c('a-spin',{staticClass:"a-spin",attrs:{"spinning":this.$store.state.loadding}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }